<template>
  <div id="kt_body" class="header-fixed header-mobile-fixed page-loading">
    <!--begin::Header Mobile-->
    <div
      id="kt_header_mobile"
      class="header-mobile bg-primary header-mobile-fixed"
    >
      <!--begin::Logo-->
      <router-link :to="{ name: 'ControllerDashboard' }">
        <img
          alt="Logo"
          src="@/assets/images/menu/logo-white.png"
          style="width: 45px  !important"
        />
      </router-link>
      <!--end::Logo-->
      <!--begin::Toolbar-->
      <div class="d-flex align-items-center">
        <b-button
          class="p-0 burger-icon burger-icon-left ml-4"
          variant="link"
          @click="mobileMenu = !mobileMenu"
        >
          <span></span>
        </b-button>
        <b-button
          class="p-0 ml-2"
          id="kt_header_mobile_topbar_toggle"
          variant="link"
          @click="mobilePanel = !mobilePanel"
        >
          <span class="svg-icon svg-icon-xl">
            <!--begin::Svg Icon | path:assets/media/svg/icons/General/User.svg-->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M12 11a4 4 0 110-8 4 4 0 010 8z" fill="#000" fill-rule="nonzero" opacity=".3"/><path d="M3 20.2c.388-4.773 4.262-7.2 8.983-7.2 4.788 0 8.722 2.293 9.015 7.2.012.195 0 .8-.751.8H3.727c-.25 0-.747-.54-.726-.8z" fill="#000" fill-rule="nonzero"/></g></svg>
            <!--end::Svg Icon-->
          </span>
        </b-button>
      </div>
      <!--end::Toolbar-->
    </div>
    <!--end::Header Mobile-->
    <div class="d-flex flex-column flex-root">
      <!--begin::Page-->
      <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Wrapper-->
        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
          <!--begin::Header-->
          <div id="kt_header" class="header flex-column header-fixed">
            <!--begin::Top-->
            <div class="header-top">
              <!--begin::Container-->
              <div
                class="container"
                :class="{ 'topbar-mobile-on': mobilePanel }"
              >
                <!--begin::Left-->
                <div class="d-none d-lg-flex align-items-center mr-3">
                  <!--begin::Logo-->
                  <router-link
                    :to="{ name: 'ControllerDashboard' }"
                    class="mr-20"
                  >
                    <img
                      alt="Logo"
                      src="@/assets/images/menu/kymatio.png"
                      style="width:150px"
                    />
                  </router-link>
                  <!--end::Logo-->
                </div>
                <!--end::Left-->
                <!--begin::Topbar-->
                <div class="topbar">
                  <!--begin::Notifications-->
                  <b-dropdown
                    class="dropdown topbar-item"
                    toggle-class="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg"
                    menu-class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-right"
                    offset=""
                    right
                    :no-caret="true"
                  >
                    <template slot="button-content">
                      <b-button
                        tag="div"
                        class="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg"
                      >
                        <span class="svg-icon svg-icon-xl">
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Media/Equalizer.svg-->
                          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><rect fill="#000" opacity=".3" x="2" y="3" width="20" height="18" rx="2"/><path d="M9.949 13.316A1 1 0 019 14H5a1 1 0 010-2h3.28l1.771-5.316c.317-.95 1.676-.897 1.92.073l1.844 7.378.79-1.582A1 1 0 0115.5 12H19a1 1 0 010 2h-2.882l-1.724 3.447c-.415.83-1.639.696-1.864-.204l-1.667-6.669-.914 2.742z" fill="#000" fill-rule="nonzero"/><circle fill="#000" opacity=".3" cx="19" cy="6" r="1"/></g></svg>
                          <!--end::Svg Icon-->
                        </span>
                      </b-button>
                    </template>
                    <b-dropdown-item>
                      <span class="btn btn-icon">
                        <span class="svg-icon svg-icon-xl">
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Media/Equalizer.svg-->
                          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><rect fill="#000" opacity=".3" x="2" y="3" width="20" height="18" rx="2"/><path d="M9.949 13.316A1 1 0 019 14H5a1 1 0 010-2h3.28l1.771-5.316c.317-.95 1.676-.897 1.92.073l1.844 7.378.79-1.582A1 1 0 0115.5 12H19a1 1 0 010 2h-2.882l-1.724 3.447c-.415.83-1.639.696-1.864-.204l-1.667-6.669-.914 2.742z" fill="#000" fill-rule="nonzero"/><circle fill="#000" opacity=".3" cx="19" cy="6" r="1"/></g></svg>
                          <!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text pt-3">
                        {{ $t("messages.menu.toggle.controller") }}
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToEmployee">
                      <span class="btn btn-icon">
                        <span class="svg-icon svg-icon-xl">
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Media/Equalizer.svg-->
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><circle fill="#000" opacity=".3" cx="12" cy="12" r="10"/><path d="M12 11a2 2 0 110-4 2 2 0 010 4zm-5 5.5c.216-2.983 2.368-4.5 4.99-4.5 2.66 0 4.846 1.433 5.009 4.5.006.122 0 .5-.418.5H7.404c-.14 0-.415-.338-.404-.5z" fill="#000" opacity=".3"/></g></svg>
                          <!--end::Svg Icon-->
                        </span>
                      </span>
                      <span class="navi-text pt-3">
                        {{ $t("messages.menu.toggle.employee") }}
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                  <!--begin::Language-->
                  <b-dropdown
                    class="dropdown topbar-item"
                    toggle-class="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg"
                    menu-class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-right"
                    offset=""
                    right
                    :no-caret="true"
                  >
                    <template slot="button-content">
                      <b-button
                        tag="div"
                        class="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg"
                      >
                        <img
                          class="h-20px w-20px rounded-sm"
                          :src="require(`@/assets/images/flags/${lang}.svg`)"
                          alt=""
                        />
                      </b-button>
                    </template>
                    <b-dropdown-item
                      v-for="lang in languages"
                      :key="lang"
                      @click="changeLanguage(lang.toLowerCase())"
                    >
                      <span class="symbol symbol-20 mr-3">
                        <img
                          :src="require(`@/assets/images/flags/${lang}.svg`)"
                          alt=""
                        />
                      </span>
                      <span class="navi-text">
                        {{ $t(`messages.generic.languages.${lang}`) }}
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                  <!--end::Language-->
                  <!--begin::User-->
                  <div class="topbar-item">
                    <div
                      class="btn btn-icon btn-hover-transparent-white w-auto d-flex align-items-center btn-lg px-2"
                      @click="panel = !panel"
                    >
                      <div class="d-flex flex-column text-right pr-3">
                        <span
                          class="text-white opacity-50 font-weight-bold font-size-sm d-none d-md-inline"
                          >{{ fullname }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <!--end::User-->
                  <div class="topbar-item">
                    <b-button
                      id="exit"
                      @click="logout()"
                      variant="light-primary"
                      class="btn btn-sm btn-light-primary font-weight-bolder"
                    >
                      {{ $t("messages.menu.userPanel.buttons.exit") }}
                    </b-button>
                  </div>
                </div>
                <!--end::Topbar-->
              </div>
              <!--end::Container-->
            </div>
            <!--end::Top-->
            <!--begin::Bottom-->
            <div class="header-bottom">
              <!--begin::Container-->
              <div class="container">
                <!--begin::Header Menu Wrapper-->
                <div
                  class="header-menu-wrapper header-menu-wrapper-left"
                  :class="{ 'header-menu-wrapper-on': mobileMenu }"
                  id="kt_header_menu_wrapper"
                >
                  <!--begin::Header Menu-->
                  <div
                    id="kt_header_menu"
                    class="header-menu header-menu-left header-menu-mobile header-menu-layout-default"
                  >
                    <!--begin::Header Nav-->
                    <ul class="menu-nav">
                      <router-link
                        :to="{ name: item.to }"
                        tag="li"
                        class="menu-item menu-item-submenu menu-item-rel"
                        active-class="menu-item-here"
                        aria-haspopup="true"
                        v-for="item in visibleMenu"
                        :key="item.to"
                      >
                        <div class="menu-link">
                          <span class="menu-text text-left">
                            {{ item.title }}
                          </span>
                          <span class="menu-desc">{{ item.subtitle }}</span>
                          <i class="menu-arrow"></i>
                        </div>
                      </router-link>
                    </ul>
                    <!--end::Header Nav-->
                  </div>
                  <!--end::Header Menu-->
                </div>
                <!--end::Header Menu Wrapper-->
              </div>
              <!--end::Container-->
            </div>
            <!--end::Bottom-->
          </div>
          <!--end::Header-->
        </div>
      </div>
    </div>
    <transition
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight"
    >
      <user-panel v-show="panel" @user-panel-closed="panel = false" />
    </transition>
    <div class="offcanvas-overlay" @click="panel = false" v-if="panel"></div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import UserPanel from "@/components/menu/UserPanel.component";

export default {
  name: "Menu",
  components: {
    UserPanel
  },
  data() {
    return {
      panel: false,
      mobilePanel: false,
      mobileMenu: false,
      profileType: localStorage.getItem("profile")
    };
  },
  computed: {
    ...mapGetters("User", ["fullname", "isUserLoaded"]),
    ...mapGetters("Constants", ["isConstantsActive", "getConstant"]),
    ...mapGetters("Auth", ["lang", "hasModule"]),
    languages() {
      return _.intersection(
        Object.keys(this.$i18n.messages),
        JSON.parse(localStorage.getItem("languages"))
      );
    },
    visibleMenu() {
      return _.filter(this.menu, item => {
        return item.service === undefined || this.hasModule([item.service]);
      });
    },
    menu() {
      return [
        {
          title: this.$t("messages.menu.controller.dashboard.title"),
          subtitle: this.$t("messages.menu.controller.dashboard.subtitle"),
          to: "ControllerDashboard"
        },
        {
          title: this.$t("messages.menu.controller.users.title"),
          subtitle: this.$t("messages.menu.controller.users.subtitle"),
          to: "Users"
        },
        {
          title: this.$t("messages.menu.controller.departments.title"),
          subtitle: this.$t("messages.menu.controller.departments.subtitle"),
          to: "Departments"
        },
        {
          title: this.$t("messages.menu.controller.orgchart.title"),
          subtitle: this.$t("messages.menu.controller.orgchart.subtitle"),
          to: "Organization"
        },
        {
          title: this.$t("messages.menu.controller.actionPlan.title"),
          subtitle: this.$t("messages.menu.controller.actionPlan.subtitle"),
          to: "ActionPlan",
          service: "risk"
        },
        {
          title: this.$tc(
            "messages.menu.controller.phishing.title",
            this.hasModule(["neurogaitas"]) ? 2 : 1
          ),
          subtitle: this.$t("messages.menu.controller.phishing.subtitle"),
          to: "ListCampaigns",
          service: "phishing"
        }
      ];
    }
  },
  methods: {
    ...mapActions("User", ["loadUser"]),
    ...mapActions("Auth", ["changeLanguage", "logout"]),
    goToEmployee() {
      this.$router.push({ name: "Dashboard" });
    }
  },
  mounted() {
    if (this.isConstantsActive && !this.isUserLoaded) {
      this.loadUser();
    }
  },
  watch: {
    isConstantsActive: function(value) {
      if (value) {
        this.loadUser();
      }
    },
    $route: function() {
      this.mobilePanel = false;
      this.mobileMenu = false;
      this.panel = false;
    },
    isUserLoaded: function(value) {
      if (!value) {
        this.loadUser();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.svg-icon > svg:focus {
  outline-width: 0;
}
</style>
<style lang="scss">
.dropdown-menu.menu-rounded {
  border-radius: 30px;
}
</style>
